import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CatalogTeamPicker } from './CatalogTeamPicker';

export const CatalogTeamPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CatalogTeamPicker',
    component: CatalogTeamPicker,
  }),
);
